import { useMemo } from "react";
import qrcode from "qrcode-generator";

/**
 * A crisp, scalable QR code rendered as a single SVG path (one <rect> field of
 * dark modules on a white quiet zone). Scales to its container — size it with
 * width/height via `className`.
 */
export function QrCode({
  text,
  className,
  dark = "#0a0a0b",
  light = "#ffffff",
}: {
  text: string;
  className?: string;
  dark?: string;
  light?: string;
}) {
  const { size, d } = useMemo(() => {
    const qr = qrcode(0, "M");
    qr.addData(text);
    qr.make();
    const n = qr.getModuleCount();
    const quiet = 3;
    let path = "";
    for (let r = 0; r < n; r++) {
      for (let c = 0; c < n; c++) {
        if (qr.isDark(r, c)) path += `M${c + quiet} ${r + quiet}h1v1h-1z`;
      }
    }
    return { size: n + quiet * 2, d: path };
  }, [text]);

  return (
    <svg
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      shapeRendering="crispEdges"
      role="img"
      aria-label="QR code"
    >
      <rect width={size} height={size} fill={light} />
      <path d={d} fill={dark} />
    </svg>
  );
}
